import { Injectable } from '@angular/core';
import { AppSettings } from '../shared/App-Settings';
import { HttpClient, HttpHeaders, HttpRequest, HttpEvent, HttpEventType, HttpResponse } from '@angular/common/http';
import { AuthenticationService } from '../core/authentication.service';
import { Observable, of, throwError } from 'rxjs';
import { tap, catchError, map } from 'rxjs/operators';
import { ResponseDTO } from '../models/response-dto';
import { Packages } from '../models/packages';
import { LocalStorageService, LocalStorageKeyOptions } from '../core/local-storage.service';
import { SessionService, SessionKeyOptions } from '../core/session.service';
import { FranchiseeFilterOption } from '../searchFilters/franchisee-filter-option';
import { DatePipe } from '@angular/common';

const apiUrl = AppSettings.API_BASE_URL + "api/";

@Injectable({
  providedIn: 'root'
})
export class FranchiseeService {

  constructor(private httpClient: HttpClient, private auth: AuthenticationService, private session: SessionService) { }

  getAllFranchises(): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}GetFranchiseeList`;

    return this.httpClient.get<any>(url, httpOptions);
  }

  addFranchisee(model): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}Franchisee`;

    return this.httpClient.post<any>(url, model, httpOptions);
  }

  updateFranchisee(model, franchiseeId): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}Franchisee/${franchiseeId}`;

    return this.httpClient.put<any>(url, model, httpOptions);
  }

  getFranchisee(franchiseeId: number): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}Franchisee/${franchiseeId}`;

    return this.httpClient.get<any>(url, httpOptions);
  }

  GetFranchiseeCollection(currentPage: number, pageSize: number, order: string, sortby: string, filter: FranchiseeFilterOption) {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}FranchisesCollection`;

    url = url + '?PageNo=' + currentPage + '&PageSize=' + pageSize + '&Sort=' + sortby + " " + order;

    if (filter.createdDate) {
      var pipe = new DatePipe('en-US');
      url = url + '&createdDate=' + pipe.transform(filter.createdDate, "MM-dd-yyyy");
    }
    if (filter.modifiedDate) {
      var pipe = new DatePipe('en-US');
      url = url + '&modifiedDate=' + pipe.transform(filter.modifiedDate, "MM-dd-yyyy");
    }

    if (filter.isActive != undefined)
      url = url + '&isActive=' + filter.isActive;

    if (filter.franchiseName)
      url = url + '&franchiseName=' + filter.franchiseName;

    if (filter.isActive)
      url = url + '&isActive=' + filter.isActive;

    return this.httpClient.get<any>(url, httpOptions);
  }


  getAllFranchisesByWarehouseId(WarehouseId): Observable<ResponseDTO> {
    
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}GetFranchiseeList`;
    if(WarehouseId != null && WarehouseId != '' && WarehouseId){
      url = url +'?warehouseId=' + WarehouseId;
    }

    return this.httpClient.get<any>(url, httpOptions);
  }

  deleteFranchisee(franchiseeId: number): Observable<ResponseDTO> {
    let accessToken = this.auth.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = `${apiUrl}Franchisee/${franchiseeId}`;

    return this.httpClient.delete<any>(url, httpOptions);
  }
}
